module.exports = __webpack_public_path__ + "static/media/brainPop.82d67882.png";